module.exports = __webpack_public_path__ + "img/palettes_cn.40bef5a.jpg";